var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show === true)?_c('QuestionarioReview',{attrs:{"docInfo":_vm.questionario,"soggetto":_vm.soggetto,"nomeSoggetto":_vm.nomeSoggetto}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }